import * as Common from "../../commons/common"

export class SumupGroup {
  exec_date: string = null
  name: string = null
  sheet_type: number = Common.SheetTypeEnum.Practice
  verify_count: number | null
  is_sort_answer_image_enable: boolean = false
  is_mask_student_info: boolean = false
  is_print_part1: boolean = false
  nendo: number
  exec_times: number
  is_use_mark_recog_field: boolean = false
  is_use_hosei: boolean = false
}

export class Examinee{
  id: number | null
  room_name: string
  student_no_character: string
  student_name: string
  birthday: string
  phone_no: string
  gender: string
  curriculums: number[]
  course_code: string
  addition: string
  user_id: number
  

  constructor(examinee: any){
    this.id = examinee.id;
    this.room_name = examinee.room_name;
    this.student_no_character = examinee.student_no_character == undefined ? null : `${examinee.student_no_character}`;
    this.student_name = examinee.student_name;
    this.birthday = examinee.birthday;
    this.phone_no = examinee.phone_no;
    this.gender = examinee.gender;
    this.curriculums = examinee.curriculums.map((x: any) => Number(x));
    this.course_code = examinee.course_code;
    this.addition = examinee.addition;
    this.user_id = examinee.user_id;
  }
}

export class BaseAssessment {
  id: number = null
  name: string = ""
  sort_no: string = ""

  constructor(x: any = null){
    if(x){
      this.id = x.id;
      this.name = x.name;
      this.sort_no = x.sort_no;
    }
  }
}
